import OTPList from './OTPList';
import {Pin} from "@mui/icons-material";

export default {
    list: OTPList,
    icon: Pin,
};
